// extracted by mini-css-extract-plugin
export var bounds = "DownloadCard-module--bounds--60743";
export var card = "DownloadCard-module--card--eceff";
export var content = "DownloadCard-module--content--3dd14";
export var date = "DownloadCard-module--date--466ce";
export var link = "DownloadCard-module--link--ca3ea";
export var row = "DownloadCard-module--row--7401b";